module.exports = __webpack_public_path__ + "static/media/Argentina_France.e454a2f9.jpeg";